import { render, staticRenderFns } from "./PointsOfInterest.vue?vue&type=template&id=75404566&"
import script from "./PointsOfInterest.vue?vue&type=script&lang=js&"
export * from "./PointsOfInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports